import {
  FormHandler,
  FormItem,
  MenuPresets,
  RelationEditor,
  TextInput,
} from '@framework/form';
import { Drawer } from '@framework/ui';
import { Button, ButtonProps, Collapse, message } from 'antd';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { v4 } from 'uuid';
import { BooleanConditionEditorInput } from '../../../../../../inputs';
import { RichTextAdvancedInput } from '../../../../../../inputs/rich-text-advanced/RichTextAdvancedInput';
import { DrawerEditorButtonRow } from '../../../../../../ui/drawer';
import { StyledDrawerCollapse } from '../../../../../../ui/drawer/StyledDrawerCollapse';
import { ISimpleTableRow, ITableRow, TableRowSchema } from '../ITableRow';
import { RowCustomFormSwitch } from '../cells/RowCustomFormSwitch';
const { Panel } = Collapse;

export interface ITableRowsWidgetEditDrawerProps {
  editor: RelationEditor<ITableRow>;
  buttonProps?: Omit<ButtonProps, 'onClick'>;
  index: number | null;
  setIndex: (index: number | null) => void;
}

export function TableRowsWidgetEditDrawer(
  props: ITableRowsWidgetEditDrawerProps,
) {
  const { editor, buttonProps, index, setIndex } = props;

  const columns = useWatch({ name: 'columns', defaultValue: [] });

  return (
    <>
      <Button
        children="+ Aggiungi Riga"
        {...buttonProps}
        onClick={() => {
          setIndex(null);
          const row = TableRowSchema.cast(
            {
              id: v4(),
              customRow: false,
              code: '',
              label: [{ type: 'text', text: '' }],
            },
            { assert: false },
          ) as ISimpleTableRow;
          editor.handle.open(row);
        }}
      />
      <Drawer
        maskClosable={false}
        title="Configurazione Riga"
        size="large"
        placement="right"
        destroyOnClose
        onClose={editor.handle.cancel}
        open={editor.handle.isVisible}
      >
        <FormHandler
          layout="vertical"
          schema={TableRowSchema as any}
          hideVisualFeedback
          initialValues={
            editor.handle.current ?? TableRowSchema.cast({}, { assert: false })
          }
          onSubmit={async rawValues => {
            try {
              const values = await TableRowSchema.validate(rawValues);
              const type = editor.handle.apply(values as ITableRow, index);
              if (type === 'updated') {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                message.success('Riga modificata');
              } else {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                message.success('Riga aggiunta');
              }
            } catch (e) {
              // eslint-disable-next-line @typescript-eslint/no-floating-promises
              message.error('Si è verificato un errore nella gestione della riga'); // prettier-ignore
              console.error(e);
            }
          }}
        >
          <FormItem name="code" label="Codice">
            <TextInput name="code" />
          </FormItem>

          <FormItem name="label" label="Etichetta">
            <RichTextAdvancedInput
              rows={4}
              name="label"
              menus={MenuPresets.Inline}
            />
          </FormItem>

          <RowCustomFormSwitch columns={columns} />

          {/* TODO Regole di validazione/visibilità */}
          <StyledDrawerCollapse defaultActiveKey={[]} ghost>
            <Panel header="Regole di Visualizzazione" key="view">
              <FormItem name="visible" label="Visibile">
                <BooleanConditionEditorInput name="visible" label="Visibile" />
              </FormItem>
              <FormItem name="enabled" label="Abilitato">
                <BooleanConditionEditorInput name="enabled" label="Abilitato" />
              </FormItem>
            </Panel>
          </StyledDrawerCollapse>

          <DrawerEditorButtonRow editor={editor} />
        </FormHandler>
      </Drawer>
    </>
  );
}
